import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@popmenu/common-ui';
import type { StyleRules } from '~/utils/withStyles';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: {
    [breakpoints.down('sm')]: {
      maxWidth: '100%',
      width: '100%',
    },
    '& .pm-form-group input': {
      boxSizing: 'content-box !important',
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '800px',
    minHeight: 'calc(100vh - 200px)',
    overflow: 'visible',
    padding: spacing(3, 2),
    width: '100%',
  },
} as const satisfies StyleRules));

type Props = {
  children: React.ReactNode,
};

const SelfSignUpStepContainer = ({ children }: Props) => {
  const classes = useStyles();

  return (
    <Container maxWidth={false} disableGutters className={classes.root}>
      {children ?? false}
    </Container>
  );
};

export default SelfSignUpStepContainer;
